import App from '@/App';
import '@/index.css';
import { SentryService } from '@/services/sentry';
import { setupDayjsExtensions } from '@/utils/setupDayjsExtensions';
import React from 'react';
import ReactDOM from 'react-dom';

SentryService.init();

setupDayjsExtensions();

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
